import { useGetPlatformLocationLogos } from "@/api/orval/multi-platform/multi-platform";
import { useBrowseLocationId } from "@/modules/anonymousBrowsing";

export const useLocationLogo = (
  platformId: string | undefined,
  locationId: string | undefined,
  isGuest: boolean | undefined,
) => {
  const browseLocationId = useBrowseLocationId();
  // Guest location reads include a default before the visitor confirms a choice.
  // Require that choice to match the resolved location, including while switching.
  const hasSelectedLocation =
    isGuest === false || (isGuest === true && browseLocationId === locationId);
  const selectedLocationId = hasSelectedLocation ? locationId : undefined;
  const { data } = useGetPlatformLocationLogos(platformId ?? "", undefined, {
    query: { enabled: !!platformId && !!selectedLocationId },
  });
  return selectedLocationId
    ? data?.find((location) => location.locationId === selectedLocationId)
    : undefined;
};
